import {actualiseBoutonsAction, actualiseLignesRésultats, actualiseRésultatsInfo, ajoutePastille} from "./dom.js";
import {MoteurDeRecherche} from "./MoteurDeRecherche.js";
import {OptionRecherche} from "./OptionRecherche.js";
import {Recherche} from "./Recherche.js";
import {Pagination} from "./Pagination.js";
import {Tri, TriDéf} from "./Tri.js";
import {Événements} from "./constantes.js";
import {GestionnaireFavoris} from "./GestionnaireFavoris.js";
import {FenêtreSurgissante} from "./composants/FenêtreSurgissante.js";
import {TriColonneInfo} from "./composants/TriColonneInfo.js";
import {TableauRecherches} from "./composants/TableauRecherches.js";
import {GestionnaireURL} from "./GestionnaireURL.js";

export class UsitoMots {

    résultatsRecherche = {};

    constructor(constructeurDeRecherche, gestionnaireOnglets, gestionnaireAlphabetPhonétique,
                gestionnaireSuggestions, gestionnaireHistorique, gestionnaireFavoris) {
        this.constructeurDeRecherche = constructeurDeRecherche;
        this.gestionnaireOnglets = gestionnaireOnglets;
        this.gestionnaireAlphabetPhonétique = gestionnaireAlphabetPhonétique;
        this.gestionnaireSuggestions = gestionnaireSuggestions;
        this.gestionnaireHistorique = gestionnaireHistorique;
        this.gestionnaireFavoris = gestionnaireFavoris;


        if (document.getElementById("critèresRechercheMots")) {

            document.addEventListener(Événements.NOUVEAU_CRITÈRE, (e) => this.nouveauCritère(e));
            document.addEventListener(Événements.NOUVELLES_DONNÉES, (e) => this.nouvellesDonnées(e));
            document.addEventListener(Événements.PAGINATION, (e) => this.nouvellePagination(e));
            document.addEventListener(Événements.TRI, (e) => this.nouveauTri(e));
            document.addEventListener(GestionnaireFavoris.Événements.RECHERCHE_FAVORIS_MODIFIÉS, (e) => this.ajusteÉtatFavori(e));
            document.addEventListener(GestionnaireFavoris.Événements.RECHERCHE_FAVORIS_MAXITEMS, (e) => this.avertissement(e.detail.message));
            document.addEventListener(TableauRecherches.Événements.RECHERCHE_FAVORI_RENOMMER, (e) => this.ajusteNomRecherche(e.detail));

            document.querySelectorAll('input[name="filtreOption"]').forEach((elem) => {
                elem.addEventListener("change", (e) => this.optionModifiée(e))
            });

            document.getElementById("résultats-actions-partager")
                .addEventListener("click", (e) => this.partagerRecherche(e));

            document.getElementById("résultats-actions-ajouterFavoris")
                .addEventListener("click", (e) => this.ajouterSupprimerAuxFavoris(e));

            document.getElementById("résultats-actions-télécharger")
                .addEventListener("click", (e) => this.téléchargerRésultatsRecherche(e));


            this.pagination = new Pagination();

            this.tri = new Tri();

            this.usitoMotsDiv = [...document.getElementsByClassName("usito-mots")][0];
            this.ancienCurseur = this.usitoMotsDiv.style.cursor;

            document.querySelectorAll(TriColonneInfo.nom).forEach((el) => {
                el.addEventListener(TriColonneInfo.Événements.changementTri,
                    (e) => this.tri.trieSur(e, el.getColonneId(), e.detail), true);
            })

            customElements.get(FenêtreSurgissante.nom) || customElements.define(FenêtreSurgissante.nom, FenêtreSurgissante);
            this.fenêtreSurgissanteÉlément = new FenêtreSurgissante();
            document.body.appendChild(this.fenêtreSurgissanteÉlément);
        }
    }

    démarre() {

        // Vérifie s'il existe une requête dans l'URL
        const url = GestionnaireURL.getUrlCourante();

        let recherche = null;
        if (GestionnaireURL.hasRechercheCompressée(url)) {
            recherche = GestionnaireURL.getRechercheCompressée(url, this.constructeurDeRecherche);
        } else if (GestionnaireURL.hasRechercheSimple(url)) {
            recherche = GestionnaireURL.getRechercheSimple(url, this.constructeurDeRecherche);
        }

        this.constructeurDeRecherche.initialise(recherche);
    }


    async optionModifiée(e) {

        const optionÉlément = document.getElementById(e.target.id);

        switch (optionÉlément.dataset.code) {
            case OptionRecherche.FILTRE_LEMMES_SEULEMENT.code:
                this.constructeurDeRecherche.setOptions(OptionRecherche.FiltreLemmesSeulementOptions);
                break;
            case OptionRecherche.FILTRE_INCLURE_VERBES_CONJUGUÉS.code:
                this.constructeurDeRecherche.setOptions(OptionRecherche.FiltreToutesLesFormesSaufVerbesConjuguésOptions);
                break;
            case OptionRecherche.FILTRE_TOUTES_LES_FORMES.code:
                this.constructeurDeRecherche.setOptions(OptionRecherche.FiltreToutesLesFormesOptions);
                break;
        }

        await MoteurDeRecherche.exécute(this.constructeurDeRecherche.recherche, this.pagination, this.tri);
    }

    nouvellePagination(e) {

        this.pagination = e.detail.pagination;

        // Toutes les données accessibles sont déjà en mémoire, il faut juste rafraîchir affichage
        actualiseLignesRésultats(this.résultatsRecherche, this.constructeurDeRecherche.recherche, this.pagination);
    }

    nouveauTri(e) {
        this.trieDonnées(e.detail.tri)
        actualiseLignesRésultats(this.résultatsRecherche, this.constructeurDeRecherche.recherche, this.pagination, e.detail.tri);
    }

    trieDonnées(tri) {
console.log("coucou", tri);
        // Tri
        this.résultatsRecherche.résultat.items.sort(Tri.orderBy(tri));

        // Mise à jour / affichage des contrôles du tri
        this.majContrôlesTri(tri);

        // On affiche toujours le nombre de résultats maximum si le tri utilisateur est actif.
        // Cela évite que des colonnes apparaissent ou disparaissent en fonction de contenu qui serait affiché ou non
        const triUtilisateurActif = tri.some(triDéf => triDéf.source === TriDéf.Source.UTILISATEUR)
        if (triUtilisateurActif) {
            this.pagination.setTailleMax();
        }
        // else {
        //     this.pagination.setTailleMin();
        // }

    }

    majContrôlesTri(tri) {
        const tcis = document.getElementById("résultats-tableau-entêtes").querySelectorAll("tri-colonne-info");

        tcis.forEach(tci => {
            const triDéfIdx = tri.findIndex((triDéf) => triDéf.colonne === tci.getColonneId());
            const triDéf = triDéfIdx === -1 ? undefined : tri[triDéfIdx];

            if (triDéf && triDéf.source === TriDéf.Source.UTILISATEUR) {
                tci.parentElement.classList.add("triActif");
                tci.setPosition(triDéfIdx + 1);
                tci.affiche(triDéf);
            } else {
                tci.parentElement.classList.remove("triActif");
                tci.masque();
            }


        });
    }

    nouvellesDonnées(nouvellesDonnéesÉvénement) {

        this.gestionnaireAlphabetPhonétique.minimiseClavierAPI();
        this.gestionnaireOnglets.changerOnglet(document.getElementById('onglet-mots'));

        this.résultatsRecherche = nouvellesDonnéesÉvénement.detail.données;
        const rechercheOriginale = nouvellesDonnéesÉvénement.detail.recherche;

        // Ne mettre à jour les données que si la recherche à l'origine des données est bien identique
        // à la recherche courante de l'utilisateur (permet d'éviter que les résultats d'une vieille requête asynchrone lente ne viennent
        // remplacer ceux d'une requête subséquente mais plus rapide.
        if (!rechercheOriginale.égale(this.constructeurDeRecherche.recherche)) {
            return;
        }

        this.trieDonnées(this.tri.triCourant)

        actualiseRésultatsInfo(this.résultatsRecherche, this.constructeurDeRecherche.recherche);

        this.pagination.ajusteAuxRésultats(this.résultatsRecherche.résultat);

        actualiseLignesRésultats(this.résultatsRecherche, this.constructeurDeRecherche.recherche, this.pagination);

        this.gestionnaireHistorique.ajouteEntrée(rechercheOriginale, this.résultatsRecherche.résultat.résultatsInfo.nbTotalRésultats);

        this.ajusteÉtatFavori();

    }

    nouveauCritère(nouveauCritèreÉvénement) {

        const critère = nouveauCritèreÉvénement.detail.critère;
        ajoutePastille(this.constructeurDeRecherche, critère);
        actualiseBoutonsAction(this.constructeurDeRecherche);
    }

    async partagerRecherche(e) {

        // Le gestionnaire d'historique a déjà placé la requête dans l'URL du navigateur
        try {
            await navigator.clipboard.writeText(window.location.href);
            this.fenêtreSurgissanteÉlément.informe("URL de la recherche copiée dans le presse-papier.");
        } catch (erreur) {
            this.fenêtreSurgissanteÉlément.avertis(erreur.message);
        }

    }

    ajouterSupprimerAuxFavoris(e) {

        const fauxÉvénement = {
            target: e.target,
            detail: {
                recherche: Object.assign(this.constructeurDeRecherche.recherche, {
                    nbTotalItems: MoteurDeRecherche.pagination.nbTotalRésultats
                })
            }
        }

        if (e.target.classList.contains("actif")) {
            this.gestionnaireFavoris.supprimeRechercheFavorite(fauxÉvénement);
            this.setFavoriActif(e.target, false);
        } else {
            this.gestionnaireFavoris.ajouteRechercheFavorite(fauxÉvénement);
            this.setFavoriActif(e.target, true);
        }

    }

    avertissement(message) {
        //alert(message);
        this.fenêtreSurgissanteÉlément.avertis(`Nombre maximum de favoris atteint (${GestionnaireFavoris.MAX_ITEMS}) !`);
    }

    ajusteNomRecherche(renommageInfo) {
        if (renommageInfo.recherche.hash === this.constructeurDeRecherche.recherche.hash) {
            const nomÉlément = document.getElementById("recherche-nom");
            nomÉlément.textContent = renommageInfo.nouveauNom;
            if (renommageInfo.nouveauNom && renommageInfo.nouveauNom.trim().length > 0) {
                nomÉlément.style.display = "block";
            } else {
                nomÉlément.style.display = "none";
            }
        }
    }

    ajusteÉtatFavori(e) {
        // Est-ce que la requête courante est dans les favoris ?
        const icôneFavori = document.getElementById("résultats-actions-ajouterFavoris");
        this.gestionnaireFavoris.getRechercheFavorite(this.constructeurDeRecherche.recherche).then(
            (recherche) => {
                if (!recherche) {
                    this.setFavoriActif(icôneFavori, false);
                } else {
                    this.setFavoriActif(icôneFavori, true);
                }
            }
        );

    }

    setFavoriActif(icôneFavori, actif) {
        if (actif) {
            icôneFavori.classList.add("i-favori-plein", "actif");
            icôneFavori.classList.remove("i-favori-vide");
        } else {
            icôneFavori.classList.remove("actif", "i-favori-plein");
            icôneFavori.classList.add("i-favori-vide");
        }
    }


    téléchargerRésultatsRecherche() {


        if (!this.résultatsRecherche.résultat.items || this.résultatsRecherche.résultat.items.length === 0) {
            return;
        }

        // const csv = this.getCSVDepuisDonnéesBrutes();
        // const csv = this.getCSVDepuisTableHTML(["motsEntête-liens"]);
        // this.téléchargerCSV(csv, "usito-mots-" + new Date().toISOString() + ".csv");

        const idColonnesÀExclure = ["motsEntête-liens"];
        const items = this.getItemsDepuisTableHTML(idColonnesÀExclure);
        this.téléchargerXLSX(this.résultatsRecherche.résultat).then(r => console.log("Fichier xslx téléchargé avec succès"));

    }

    getItemsDepuisTableHTML(idColonnesÀExclure) {

        let entêtesHTML = document.getElementById("résultats-tableau-entêtes")
            .getElementsByTagName("tr");

        const ligneEntêteÉléments = Object.values(entêtesHTML);
        const ths = [...ligneEntêteÉléments[0].getElementsByTagName("th")];
        const entêtes = [];
        const indexColonnesÀExclure = [];

        for (i = 0; i < ths.length; i++) {
            let th = ths[i];
            let indexÀExclure = idColonnesÀExclure.findIndex((idExclu) => idExclu === th.id);
            if (indexÀExclure !== -1) {
                indexColonnesÀExclure.push(i);
            } else {
                entêtes.push(th.innerText.trim());
            }
        }

        const lignesHTML = document.getElementById("résultats-tableau-lignes")
            .getElementsByTagName("tr");

        const lignes = Object.values(lignesHTML)
            .map((ligne) =>
                [...ligne.getElementsByTagName("td")]
                    .filter((nomColonne, index) => !indexColonnesÀExclure.includes(index))
            );

        return [...lignes].map((ligne) => {

            let item = {};

            entêtes.forEach((entête, index) => {
                const nomEntêteAPI = this.getNomFormatAPI(entête);
                item[nomEntêteAPI] = this.getValeurFormatAPI(ligne[index].textContent.trim(), nomEntêteAPI);
            })

            return item;

        });
    }

    getValeurFormatAPI(valeur, nomEntêteAPI) {
        switch (nomEntêteAPI) {
            case "prononciations" :
                return valeur.split(",").map((v) => {
                    return v.replaceAll(/[\[\]]/g, "");
                });
            case "étiquettes" :
                return valeur.split(",");
            default :
                return valeur;
        }
    }

    getNomFormatAPI(nomEntêteIU) {
        switch (nomEntêteIU) {
            case "Mot" :
            case "Mot / Lemme":
                return "graphie";
            case "Phonétique" :
                return "prononciations";
            case "Lemme" :
                return "graphieLemme";
            case "MEQ" :
                return "étiquettes";
            default:
                return nomEntêteIU.toLowerCase();
        }
    }

    getCSVDepuisTableHTML(idColonnesÀExclure) {

        let entêtesHTML = document.getElementById("résultats-tableau-entêtes")
            .getElementsByTagName("tr");

        const ligneEntêteÉléments = Object.values(entêtesHTML);
        const indexColonnesÀExclure = [...ligneEntêteÉléments
            // Normalement toujours une seule ligne!
            [0]
            .getElementsByTagName("th")]
            .filter((th) => idColonnesÀExclure.includes(th.id))
            .map((v, i) => i);

        const entêtes = ligneEntêteÉléments
            .map((entête) => entête.innerText.split("\t")
                .filter((nomColonne, index) => !indexColonnesÀExclure.includes(index))
                .map((nomColonne) => nomColonne.trim())
            );

        const lignesHTML = document.getElementById("résultats-tableau-lignes")
            .getElementsByTagName("tr");

        const lignes = Object.values(lignesHTML)
            .map((ligne) => ligne.innerText.split("\t")
                .filter((nomColonne, index) => !indexColonnesÀExclure.includes(index))
            );


        // retour à la ligne
        return [...entêtes, ...lignes].map((ligne) =>
            ligne.map(v => v.replaceAll('"', '""'))  // protège les guillemets potentiels dans une valeur
                .map(v => v.replaceAll('<span>', ''))
                .map(v => v.replaceAll('</span>', ''))
                .map(v => `"${v}"`)  // mise entre guillemets de chaque valeur
                .join(',')  // concaténation des valeurs, séparées par des virgules
        ).join('\r\n');
    }

    /**
     * Note : prévoir un moyen d'accéder à ces données pour certains utilisateurs.
     * @returns {string}
     */
    getCSVDepuisDonnéesBrutes() {
        const entête = Object.keys(this.résultatsRecherche.résultat.items[0]);
        const lignes = this.résultatsRecherche.résultat.items.map((ligne) => Object.values(ligne));

        // retour à la ligne
        return [entête, ...lignes].map(ligne =>
            ligne.map(String) // conversion en String de chaque "cellule" (valeur) de la ligne. Autrement dit la ligne devient un tableau de String
                .map(v => v.replaceAll('"', '""'))  // protège les guillemets potentiels dans une valeur
                .map(v => v.replaceAll('<span>', ''))
                .map(v => v.replaceAll('</span>', ''))
                .map(v => `"${v}"`)  // mise entre guillemets de chaque valeur
                .join(',')  // concaténation des valeurs, séparées par des virgules
        ).join('\r\n');
    }

    téléchargerCSV(csv, nomFichier) {
        // Création du blob
        let blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
        let url = URL.createObjectURL(blob);
        this.téléchargementAvecNom(url, nomFichier);
    }

    téléchargementAvecNom(url, nomFichier) {
        // Création d'un lien pour le téléchargement
        let aÉlément = document.createElement('a');
        aÉlément.href = url;
        aÉlément.setAttribute('download', nomFichier);
        aÉlément.click();
        aÉlément.remove();
    }

    async téléchargerXLSX(résultat) {

        const url = new URL("/v2/mots/exportation/xlsx", window.location.origin);
        const corps = {
            recherche: Recherche.prépareSérialisation(this.constructeurDeRecherche.recherche),
            résultat: {
                items: résultat.items,
                résultatsInfo: résultat.résultatsInfo
            }
        }

        const request = new Request(url);

        let nomFichier = "usito-mots.xlsx";

        return fetch(request, {
            method: 'POST',
            body: JSON.stringify(corps),
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            }
        })
            .then(réponse => {
                if (!réponse.ok) {
                    if (réponse.status === 400) {
                        throw new Error(`Demande de téléchargement non valide`);
                    } else {
                        throw new Error(`Erreur lors du téléchargement (${réponse.status})`);
                    }
                }
                const cdEntête = réponse.headers.get("Content-Disposition");
                const parties = cdEntête.split(';');
                nomFichier = parties[1].split('=')[1].replace(/['"]/g, '');
                return réponse.blob()
            })
            .then(blob => URL.createObjectURL(blob))
            .then(url => {
                // Plus simple, mais ne permet pas de personnaliser le nom de fichier
                //window.open(url, '_blank');
                this.téléchargementAvecNom(url, nomFichier);
                URL.revokeObjectURL(url);
            })
            .catch(reason => {
                console.error(reason);
            });


    }


}
